/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Full_Stack_Web_Apps_Tlm_3Inputs */

const en_svc_full_stack_web_apps_tlm_3 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`deploy`)
};

const ar_svc_full_stack_web_apps_tlm_3 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`النشر`)
};

const bn_svc_full_stack_web_apps_tlm_3 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`deploy`)
};

const de_svc_full_stack_web_apps_tlm_3 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bereitstellen`)
};

const es_svc_full_stack_web_apps_tlm_3 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`implementar`)
};

const fr_svc_full_stack_web_apps_tlm_3 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`déployer`)
};

const pt_svc_full_stack_web_apps_tlm_3 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`implantar`)
};

const zh_svc_full_stack_web_apps_tlm_3 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`部署`)
};

const tr_svc_full_stack_web_apps_tlm_3 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dağıtma`)
};

const ru_svc_full_stack_web_apps_tlm_3 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`развернуть`)
};

const pl_svc_full_stack_web_apps_tlm_3 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`wdrożenie`)
};

/**
* | output |
* | --- |
* | "deploy" |
*
* @param {Svc_Full_Stack_Web_Apps_Tlm_3Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_full_stack_web_apps_tlm_3 = /** @type {((inputs?: Svc_Full_Stack_Web_Apps_Tlm_3Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Full_Stack_Web_Apps_Tlm_3Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_full_stack_web_apps_tlm_3(inputs)
	if (locale === "bn") return bn_svc_full_stack_web_apps_tlm_3(inputs)
	if (locale === "de") return de_svc_full_stack_web_apps_tlm_3(inputs)
	if (locale === "es") return es_svc_full_stack_web_apps_tlm_3(inputs)
	if (locale === "fr") return fr_svc_full_stack_web_apps_tlm_3(inputs)
	if (locale === "pt") return pt_svc_full_stack_web_apps_tlm_3(inputs)
	if (locale === "zh") return zh_svc_full_stack_web_apps_tlm_3(inputs)
	if (locale === "tr") return tr_svc_full_stack_web_apps_tlm_3(inputs)
	if (locale === "ru") return ru_svc_full_stack_web_apps_tlm_3(inputs)
	if (locale === "pl") return pl_svc_full_stack_web_apps_tlm_3(inputs)
	return en_svc_full_stack_web_apps_tlm_3(inputs)
});
export { svc_full_stack_web_apps_tlm_3 as "svc_full-stack-web-apps_tlm_3" }